/** Iframe preview downloads instead of rendering when the object is served as an attachment. */
export function contentDispositionIsAttachment(cd) {
  return typeof cd === 'string' && /^\s*attachment\b/i.test(cd);
}

export function parseFilenameFromContentDisposition(cd) {
  if (!cd) {
    return null;
  }
  const star = cd.match(/filename\*=UTF-8''([^;]+)/i);
  if (star) {
    try {
      return decodeURIComponent(star[1].trim());
    } catch {
      return star[1].trim();
    }
  }
  const quoted = cd.match(/filename="((?:\\.|[^"\\])*)"/i);
  return quoted ? quoted[1].replace(/\\"/g, '"') : null;
}

export function saveBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
